import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Game} from "../Game";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import { SymbolStates } from "../reels/Symbol";

export class NormalBetIdlePresentation implements FlowStatePresentation {

    private _tlArr: gsap.core.Timeline[] | null[] = [null, null, null, null];

    public start(flowStateController: FlowStateController): void {
        for (let idx=0; idx < this._tlArr.length; idx++){
            this._tlArr[idx] = gsap.timeline({
                delay: MathHelper.randomIntInRange(13, 20),
                repeat: -1,
                repeatDelay: MathHelper.randomIntInRange(13, 20)
            });
        }

        Game.monsterReelsView.monsterSymbolContainer.children.forEach((monsterSymbol: PIXI.DisplayObject, idx: number) => {
            const randomIdleAnimStr: string = "idle_" + MathHelper.randomIntInRange(1, 6);
            this._tlArr[idx]?.add((monsterSymbol as MonsterSymbol).getStateAnimation(randomIdleAnimStr, 5))
            .add(()=>{
                (monsterSymbol as MonsterSymbol).animation.state.setAnimation(5, SymbolStates.NORMAL, true);
            })
        })

        Game.model.buyFeatureName = ""; // #232

        Game.scatterInventory.stopAnticipation();
        Game.scatterInventory.controlScatterAttentionOnWalk(true);
        flowStateController.finish();
    }

    public killIdle(): void {
        for (let idx=0; idx < this._tlArr.length; idx++){
            if (this._tlArr[idx]){
                this._tlArr[idx]?.pause();
                this._tlArr[idx]?.kill();
                this._tlArr[idx] = null;
            }
        }
    }
}